(function () {
  const armStickers = () => {
    const stickers = document.querySelectorAll('[data-sticker]');
    if (!stickers.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-slapped');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    stickers.forEach((sticker) => {
      sticker.classList.add('is-armed');
      io.observe(sticker);
    });
  };

  // Closed, the menu is inert (no hidden tab stops). Open, it keeps focus
  // inside the panel and hands it back to the button that opened it.
  const initNav = () => {
    const nav = document.getElementById('slb-nav');
    if (!nav) return;
    const panel = nav.querySelector('.slb-nav-panel');
    const closeBtn = document.getElementById('slb-nav-close');
    const openers = document.querySelectorAll('[data-nav-open]');
    let opener = null;

    const lockScroll = (on) => {
      if (window.SLB?.lockScroll) window.SLB.lockScroll('nav', on);
      else document.body.style.overflow = on ? 'hidden' : '';
    };
    const focusables = () =>
      Array.from(panel?.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])') || []).filter(
        (el) => el.getClientRects().length > 0
      );

    const isOpen = () => nav.getAttribute('data-open') === 'true';
    const setOpen = (open) => {
      if (open === isOpen()) return;
      nav.setAttribute('data-open', String(open));
      nav.inert = !open;
      openers.forEach((el) => el.setAttribute('aria-expanded', String(open)));
      lockScroll(open);
      if (open) {
        opener = document.activeElement;
        (closeBtn || focusables()[0])?.focus();
      } else {
        if (opener && opener.isConnected && !nav.contains(opener)) opener.focus();
        opener = null;
      }
    };
    nav.inert = !isOpen();

    openers.forEach((el) => {
      el.addEventListener('click', () => setOpen(true));
    });
    closeBtn?.addEventListener('click', () => setOpen(false));
    document.getElementById('slb-nav-scrim')?.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (e) => {
      if (!isOpen()) return;
      if (e.key === 'Escape') {
        setOpen(false);
        return;
      }
      if (e.key !== 'Tab') return;
      const list = focusables();
      if (!list.length) return;
      const first = list[0];
      const last = list[list.length - 1];
      const inside = panel.contains(document.activeElement);
      if (e.shiftKey && (!inside || document.activeElement === first)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (!inside || document.activeElement === last)) {
        e.preventDefault();
        first.focus();
      }
    });
    // Safari's default Tab skips links, so it can step past the last stop
    // without the Tab handler above seeing it; pull focus back in.
    document.addEventListener('focusin', (e) => {
      if (!isOpen() || panel.contains(e.target)) return;
      (focusables()[0] || panel).focus();
    });
  };

  const boot = () => {
    armStickers();
    initNav();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
